module.exports = __webpack_public_path__ + "img/15-1.8b4777c5.jpg";